import { render } from "./NoResults.vue?vue&type=template&id=b412ea44&ts=true"
import script from "./NoResults.vue?vue&type=script&lang=ts"
export * from "./NoResults.vue?vue&type=script&lang=ts"

import "./NoResults.vue?vue&type=style&index=0&id=b412ea44&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__